var _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleGradientIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 146,
    height: 146
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138 72.8472C138 108.646 108.914 137.694 73 137.694C37.0857 137.694 8 108.646 8 72.8472C8 37.0489 37.0857 8 73 8C108.914 8 138 37.0489 138 72.8472Z",
    stroke: "#7AC166",
    strokeWidth: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138 72.8472C138 108.646 108.914 137.694 73 137.694C37.0857 137.694 8 108.646 8 72.8472C8 37.0489 37.0857 8 73 8C108.914 8 138 37.0489 138 72.8472Z",
    stroke: "#32B76C",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 72.8472C138 108.646 108.914 137.694 73 137.694C37.0857 137.694 8 108.646 8 72.8472C8 37.0489 37.0857 8 73 8C108.914 8 138 37.0489 138 72.8472Z",
    stroke: "url(#paint0_linear)",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138 72.8472C138 108.646 108.914 137.694 73 137.694C37.0857 137.694 8 108.646 8 72.8472C8 37.0489 37.0857 8 73 8C108.914 8 138 37.0489 138 72.8472Z",
    stroke: "url(#paint1_linear)",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0002 70L-11.5 57.5L15.5 12.5L73.0001 -5.50006L73.0002 70Z",
    fill: "#80BA5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 91.9999,
    y1: 137,
    x2: -21.0001,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3CB3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CB3D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 73,
    y1: 0.00000340459,
    x2: 16,
    y2: 98.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CB3D",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGradientIcon);
export default __webpack_public_path__ + "static/media/circleGradient_icon.f5accadd54138d2dbd449d6c2594281b.svg";
export { ForwardRef as ReactComponent };